var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEngNext(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 7,
    height: 12.25,
    viewBox: "0 0 7 12.25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Symbol",
    d: "M0.875 12.25C0.638021 12.25 0.428385 12.168 0.246094 12.0039C0.0820312 11.8216 0 11.612 0 11.375C0 11.138 0.0820312 10.9284 0.246094 10.7461L4.89453 6.125L0.246094 1.50391C0.0820312 1.32161 0 1.11198 0 0.875C0 0.638021 0.0820312 0.428385 0.246094 0.246094C0.428385 0.0820312 0.638021 0 0.875 0C1.11198 0 1.32161 0.0820312 1.50391 0.246094L6.75391 5.49609C6.91797 5.67839 7 5.88802 7 6.125C7 6.36198 6.91797 6.57161 6.75391 6.75391L1.50391 12.0039C1.32161 12.168 1.11198 12.25 0.875 12.25V12.25V12.25",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngNext);
export default __webpack_public_path__ + "static/media/eng-next.aa58dea35550e955522377e1634a7853.svg";
export { ForwardRef as ReactComponent };